(() => {
  if (window.__cartShopInstallmentsUkInit) return;
  window.__cartShopInstallmentsUkInit = true;

  const DETECT_KEY = 'visitor-country-iso';

  const readSession = (key) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  };

  const writeSession = (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {}
  };

  const fromCloudflare = () =>
    fetch('https://www.cloudflare.com/cdn-cgi/trace', { cache: 'no-store' })
      .then((res) => res.text())
      .then((text) => {
        const match = text.match(/loc=([A-Z]{2})/);
        return match ? match[1] : null;
      });

  const fromIpapi = () =>
    fetch('https://ipapi.co/country/', { cache: 'no-store' })
      .then((res) => res.text())
      .then((text) => {
        const iso = (text || '').trim().toUpperCase();
        return /^[A-Z]{2}$/.test(iso) ? iso : null;
      });

  const detectCountry = () => {
    const cached = readSession(DETECT_KEY);
    if (cached) return Promise.resolve(cached);

    return fromCloudflare()
      .catch(() => null)
      .then((iso) => iso || fromIpapi().catch(() => null))
      .then((iso) => {
        if (iso) writeSession(DETECT_KEY, iso);
        return iso;
      });
  };

  const revealUkInstallments = () => {
    document.querySelectorAll('cart-item-shop-installments[data-uk-market="false"]').forEach((el) => {
      el.classList.remove('cart-item-shop-installments--hidden');
      el.removeAttribute('hidden');
    });
  };

  const refreshUkInstallments = () => {
    if (!document.querySelector('cart-item-shop-installments[data-uk-market="false"]')) return;

    detectCountry().then((country) => {
      if (country && country.toUpperCase() === 'GB') revealUkInstallments();
    });
  };

  class CartItemShopInstallments extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ukMarket === 'true') return;

      detectCountry().then((country) => {
        if (country && country.toUpperCase() === 'GB') this.reveal();
      });
    }

    reveal() {
      this.classList.remove('cart-item-shop-installments--hidden');
      this.removeAttribute('hidden');
    }
  }

  if (!customElements.get('cart-item-shop-installments')) {
    customElements.define('cart-item-shop-installments', CartItemShopInstallments);
  }

  const attachSubscriptions = () => {
    if (window.__cartShopInstallmentsSubscribed) return;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshUkInstallments);
      window.__cartShopInstallmentsSubscribed = true;
    }
    if (!window.__cartShopInstallmentsRefreshBound) {
      document.addEventListener('cart:refresh', refreshUkInstallments);
      window.__cartShopInstallmentsRefreshBound = true;
    }
  };

  const setup = () => {
    attachSubscriptions();
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      let tries = 0;
      const timer = setInterval(() => {
        attachSubscriptions();
        tries += 1;
        if ((typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') || tries > 50) {
          clearInterval(timer);
        }
      }, 100);
    }
    refreshUkInstallments();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
